export function floatingBox() {
  document.addEventListener('DOMContentLoaded', () => {
    const floatingContainers = document.querySelectorAll('.floating-container');
    if (floatingContainers.length) {
      floatingContainers.forEach(container => {
        const floatingBoxes = container.querySelectorAll(".floating-box");
        if (floatingBoxes.length) {
          if(!hasTouchScreen()) {
            // ----------------------------------
            // PCなど、タッチスクリーンでない場合の既存挙動
            // ----------------------------------
            floatingBoxes.forEach(box => {
              let wh, containerHeight, containerOffsetTop, containerOffsetBottom, boxHeight, floatEnd, offsetTopParam;

              const handleResize = () => {
                const offsetEl = document.querySelector('.header');
                offsetTopParam = offsetEl ? offsetEl.offsetHeight : 0;
                wh = window.innerHeight;
                containerHeight = container.offsetHeight;
                containerOffsetTop = container.offsetTop - offsetTopParam;
                containerOffsetBottom = container.offsetTop + container.offsetHeight;
                boxHeight = box.offsetHeight;
                floatEnd = container.offsetHeight - boxHeight;
                container.style.height = `${containerHeight}px`;
              };

              const handleScroll = () => {
                const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
                const scBottom = scTop + wh;

                if (scTop >= containerOffsetTop && scBottom <= containerOffsetBottom) {
                  const scrollRange = containerOffsetBottom - wh; 
                  const scPercent = (scTop - containerOffsetTop) / (scrollRange - containerOffsetTop);
                  const floatAmount = scPercent * floatEnd; 
                  if (floatAmount <= floatEnd) {
                    box.style.transform = `translate3d(0,${floatAmount}px,0)`;
                  } else {
                    box.style.transform = `translate3d(0,${floatEnd}px,0)`;
                  }
                } else if (scTop < containerOffsetTop) {
                  // スクロール位置がコンテナ上部よりも上の場合は初期位置に戻す
                  box.style.transform = `translate3d(0,0,0)`;
                } else if (scBottom > containerOffsetBottom) {
                  // スクロール位置がコンテナ下部よりも下の場合は最大移動量に固定
                  box.style.transform = `translate3d(0,${floatEnd}px,0)`;
                }
              };

              // 初期実行
              handleResize();
              handleScroll();

              // リサイズイベント
              let lastInnerWidth = window.innerWidth;
              window.addEventListener('resize', () => {
                if (lastInnerWidth !== window.innerWidth) {
                  lastInnerWidth = window.innerWidth;
                  handleResize();
                  handleScroll();
                }
              });

              // スクロールイベント
              window.addEventListener('scroll', handleScroll);

              // 一定間隔でサイズを再計算（画像が遅延読み込みなどの場合用）
              setInterval(handleResize, 1000);
            });
          } else {
            // ----------------------------------
            // タッチスクリーンの場合の挙動修正
            // （スクロール終了後100msしてから位置を更新）
            // ----------------------------------
            floatingBoxes.forEach(box => {
              let wh, containerHeight, containerOffsetTop, containerOffsetBottom, boxHeight, floatEnd, offsetTopParam;
              let scrollTimerId = null;  // スクロール後の処理をためるためのタイマーID

              const handleResize = () => {
                const offsetEl = document.querySelector('.header');
                offsetTopParam = offsetEl ? offsetEl.offsetHeight : 0;
                wh = window.innerHeight;
                containerHeight = container.offsetHeight;
                containerOffsetTop = container.offsetTop - offsetTopParam;
                containerOffsetBottom = container.offsetTop + container.offsetHeight;
                boxHeight = box.offsetHeight;
                floatEnd = container.offsetHeight - boxHeight;
                container.style.height = `${containerHeight}px`;
              };

              // 実際の位置を更新する処理
              const updateBoxPosition = () => {
                const scTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
                const scBottom = scTop + wh;

                if (scTop >= containerOffsetTop && scBottom <= containerOffsetBottom) {
                  const scrollRange = containerOffsetBottom - wh;
                  const scPercent = (scTop - containerOffsetTop) / (scrollRange - containerOffsetTop);
                  const floatAmount = scPercent * floatEnd;
                  if (floatAmount <= floatEnd) {
                    box.style.transform = `translate3d(0,${floatAmount}px,0)`;
                  } else {
                    box.style.transform = `translate3d(0,${floatEnd}px,0)`;
                  }
                } else if (scTop < containerOffsetTop) {
                  box.style.transform = `translate3d(0,0,0)`;
                } else if (scBottom > containerOffsetBottom) {
                  box.style.transform = `translate3d(0,${floatEnd}px,0)`;
                }
              };

              // スクロールを「まとめて」扱うための処理
              const handleScroll = () => {
                if (scrollTimerId) clearTimeout(scrollTimerId); 
                // スクロール中はタイマーをキャンセルし、最後のスクロールから100ms後に位置を更新
                scrollTimerId = setTimeout(() => {
                  updateBoxPosition();
                }, 50); 
              };

              // 初期実行
              handleResize();
              // 最初の描画
              updateBoxPosition();

              // リサイズイベント
              let lastInnerWidth = window.innerWidth;
              window.addEventListener('resize', () => {
                if (lastInnerWidth !== window.innerWidth) {
                  lastInnerWidth = window.innerWidth;
                  handleResize();
                  // リサイズが完了したらすぐ更新
                  updateBoxPosition();
                }
              });

              // スクロールイベント
              window.addEventListener('scroll', handleScroll);

              // 一定間隔でサイズを再計算（画像が遅延読み込みなどの場合用）
              setInterval(handleResize, 1000);
            });
          }
        }
      });
    }
  });
}